import { z } from "zod";

const CreateInventoryCategorySchema = z.object({
    property_id: z.string().uuid("Invalid property ID"),
    name: z.string().min(1, "Name is required"),
});

export { CreateInventoryCategorySchema };
export type CreateInventoryCategoryFormData = z.infer<typeof CreateInventoryCategorySchema>;
